import { useEffect, useState } from 'react';
import { platformApi } from '../lib/api.js';

export default function PlatformAudit() {
  const [events, setEvents] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    platformApi.audit().then(r => setEvents(r.events)).catch(e => setErr(e.body?.message || e.message));
  }, []);
  return (
    <div className="space-y-3">
      <h1 className="text-2xl font-bold">Audit log</h1>
      {err && <div className="bg-red-50 border border-red-200 text-red-700 rounded p-3 text-sm">{err}</div>}
      <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-600">
            <tr>
              <th className="px-3 py-2 text-left">When</th>
              <th className="px-3 py-2 text-left">Actor</th>
              <th className="px-3 py-2 text-left">Action</th>
              <th className="px-3 py-2 text-left">Target</th>
              <th className="px-3 py-2 text-left">Tenant</th>
              <th className="px-3 py-2 text-left">Payload</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {events?.map(e => (
              <tr key={e.id}>
                <td className="px-3 py-2 text-xs">{new Date(e.occurred_at).toLocaleString()}</td>
                <td className="px-3 py-2">{e.actor_email || <span className="text-slate-400">—</span>}</td>
                <td className="px-3 py-2 font-mono text-xs">{e.action}</td>
                <td className="px-3 py-2 font-mono text-xs">{e.target_type ? `${e.target_type}/${e.target_id?.slice(0,8)}` : '—'}</td>
                <td className="px-3 py-2 font-mono text-xs">{e.tenant_id?.slice(0,8) || '—'}</td>
                <td className="px-3 py-2 font-mono text-[11px] text-slate-600">
                  {e.payload ? JSON.stringify(e.payload).slice(0, 80) : ''}
                </td>
              </tr>
            ))}
            {events && !events.length && (
              <tr><td colSpan={6} className="px-3 py-10 text-center text-slate-500">No events yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
